"use strict";

var jwt = require("jsonwebtoken");

import {TokenGenerator} from "./tokenGenerator";
import {delegate_withRefreshToken, tokenInfo, delegate_withIdToken} from "./auth0Api";
export {
    TokenGenerator,
    delegate_withRefreshToken,
    tokenInfo,
    delegate_withIdToken
}

// export const _tokenGeneratorObj = function(clientId, globalClientSecret) {
//     return {
//         _clientId: clientId,
//         tokenSecret: globalClientSecret,
//     };
// };
//
// export const _stub = function (sandbox, auth0Api) {
//     var secret = new Buffer("test");
//
//     var generateToken = function () {
//         return jwt.sign({
//             exp: Math.floor(Date.now()/1000) + 1
//         }, secret, {});
//     };
//
//     sandbox.stub(auth0Api, "delegate_withRefreshToken", function (refreshToken, options, callback) {
//         return setImmediate(callback.bind(null, null, {
//             token_type: "Bearer",
//             expiresIn: 36000,
//             id_token: generateToken()
//         }));
//     });
//
//     sandbox.stub(auth0Api, "delegate_withIdToken", function (idToken, options, callback) {
//         return setImmediate(callback.bind(null, null, {
//             token_type: "Bearer",
//             expiresIn: 36000,
//             id_token: generateToken()
//         }));
//     });
//
//     sandbox.stub(auth0Api, "tokenInfo", function (idToken, callback) {
//         return setImmediate(callback.bind(null, null, {
//             "kind":"admin#directory#user",
//             "id":"123456789012345678901",
//             "etag":"\"16D6JySr2ja3om9wXLZ0Y3KEeUo/hwWRkosUSI0ZdCdCpU4X48s1xG8\"",
//             "primaryEmail":"someone@withjoy.com",
//             "name":"Someone Somewhere",
//             "isAdmin":true,
//             "isDelegatedAdmin":false,
//             "lastLoginTime":"2014-12-22T22:16:08.000Z",
//             "creationTime":"2014-11-27T04:24:20.000Z",
//             "agreedToTerms":true,
//             "suspended":false,
//             "changePasswordAtNextLogin":false,
//             "ipWhitelisted":false,
//             "emails":[
//                 {
//                     "address":"someone@joylife.io"
//                 },
//                 {
//                     "address":"someone@withjoy.us"
//                 },
//                 {
//                     "address":"someone@withjoy.com",
//                     "primary":true
//                 }
//             ],
//             "nonEditableAliases":[
//                 "someone@withjoy.us",
//                 "someone@withjoy.com.test-google-a.com",
//                 "someone@joylife.io"
//             ],
//             "customerId":"C02e2c4hl",
//             "orgUnitPath":"/",
//             "isMailboxSetup":true,
//             "includeInGlobalAddressList":true,
//             "is_admin":true,
//             "is_suspended":false,
//             "is_ipWhitelisted":false,
//             "tou_accepted":true,
//             "email":"someone@withjoy.com",
//             "given_name":"Someone",
//             "family_name":"Somewhere",
//             "picture":
//                 "https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/photo.jpg",
//             "gender":"male",
//             "locale":"en",
//             "groups":[
//                 "Careers",
//                 "CTO",
//                 "Founders",
//                 "Jobs",
//                 "Services",
//                 "Support"
//             ],
//             "nickname":"someone",
//             "awsRole":"arn:aws:iam::992539445445:role/Auth0Admin,arn:aws:iam::992539445445:saml-provider/Auth0",
//             "awsRoleSession":"someone@google-apps",
//             "email_verified":true,
//             "clientID":"fake_client_id",
//             "user_id":"google-apps|someone@withjoy.com",
//             "identities":[
//                 {
//                     "access_token":"fakeToken",
//                     "provider":"google-apps",
//                     "user_id":"someone@withjoy.com",
//                     "connection":"withjoy.com",
//                     "isSocial":false
//                 }
//             ],
//             "created_at":"2014-11-29T20:46:03.203Z",
//             "global_client_id":"fake_global_client_id"
//         }));
//     });
// };